import { render, staticRenderFns } from "./modalLeecherosCodigo.vue?vue&type=template&id=03c04bb2&scoped=true&"
import script from "./modalLeecherosCodigo.vue?vue&type=script&lang=js&"
export * from "./modalLeecherosCodigo.vue?vue&type=script&lang=js&"
import style0 from "./modalLeecherosCodigo.vue?vue&type=style&index=0&id=03c04bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c04bb2",
  null
  
)

export default component.exports